import React, { useState, useEffect } from "react";
import { Header } from "../Header";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { local_signage, local_url } from "../Const";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';





// Format date as YYYYMMDD for API
const formatDateForAPI = (date) => {
  if (!date) return "";
  if (typeof date === 'string') {
    const [year, month, day] = date.split('-');
    return `${year}${month}${day}`;
  }
  // If it's a dayjs object
  return date.format('YYYYMMDD');
};

export const SaleOrderReport = () => {
  const today = dayjs();
  const sixtyDaysAgo = today.subtract(30, 'day');

  const [ledgerData, setLedgerData] = useState([]);
  const [displayData, setDisplayData] = useState([]); // Data to be displayed (paginated)
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState(sixtyDaysAgo);
  const [toDate, setToDate] = useState(today);
  const [sfAreas, setSfAreas] = useState([]);
  const [selectedSfAreaId, setSelectedSfAreaId] = useState("");
  const [businessChannels, setBusinessChannels] = useState([]);
  const [selectedChannelType, setSelectedChannelType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [fetchingData, setFetchingData] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [delayFilter, setDelayFilter] = useState("ALL");
  const [paymentGateways, setPaymentGateways] = useState([]);
  const [selectedPaymentModes, setSelectedPaymentModes] = useState([]);

  // Date validation state
  const [isDateRangeValid, setIsDateRangeValid] = useState(true);
  const [hasSubmittedData, setHasSubmittedData] = useState(false);
  
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;

  // Enhanced Styles Object
  const styles = {
    container: {
      width: '100vw',
      height: '90vh',
      overflow: 'auto',
      backgroundColor: '#f8fafc',
      fontFamily: '"Inter", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
      color: '#1e293b',
      padding: '8px'
    },
    errorMessage: {
      backgroundColor: '#fee2e2',
      border: '1px solid #fecaca',
      color: '#dc2626',
      padding: '6px 10px',
      borderRadius: '4px',
      marginBottom: '8px',
      fontSize: '12px',
      fontWeight: '500',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
    inputContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '10px',
      padding: '8px',
      backgroundColor: '#ffffff',
      borderRadius: '6px',
      boxShadow: '0 2px 4px -1px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0',
      flexWrap: 'wrap'
    },
    dropdown: {
      padding: '6px 8px',
      border: '1px solid #e2e8f0',
      borderRadius: '4px',
      fontSize: '12px',
      backgroundColor: '#ffffff',
      color: '#374151',
      cursor: 'pointer',
      minWidth: '140px',
      transition: 'all 0.2s ease-in-out',
      outline: 'none',
      appearance: 'none',
      backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e")',
      backgroundPosition: 'right 8px center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '12px',
      paddingRight: '24px',
      ':hover': {
        borderColor: '#3b82f6',
        boxShadow: '0 2px 4px -1px rgba(59, 130, 246, 0.1)'
      }
    },
    datePickerContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column'
    },
    submitButton: {
      padding: '6px 12px',
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      border: 'none',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      boxShadow: '0 2px 4px -1px rgba(59, 130, 246, 0.3)',
      outline: 'none',
      minWidth: '80px'
    },
    exportButton: {
      padding: '6px 12px',
      backgroundColor: '#10b981',
      color: '#ffffff',
      border: 'none',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      boxShadow: '0 2px 4px -1px rgba(16, 185, 129, 0.3)',
      outline: 'none',
      minWidth: '90px'
    },
    searchContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '8px',
      padding: '6px 8px',
      backgroundColor: '#ffffff',
      borderRadius: '4px',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
      border: '1px solid #e2e8f0',
      flexWrap: 'wrap'
    },
    searchInput: {
      padding: '6px 8px',
      border: '1px solid #e2e8f0',
      borderRadius: '4px',
      fontSize: '12px',
      flex: '1',
      minWidth: '200px',
      backgroundColor: '#f8fafc',
      color: '#374151',
      transition: 'all 0.2s ease-in-out',
      outline: 'none',
      ':focus': {
        borderColor: '#3b82f6',
        backgroundColor: '#ffffff',
        boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.1)'
      }
    },
    dataCount: {
      fontSize: '11px',
      fontWeight: '600',
      color: '#6366f1',
      backgroundColor: '#eef2ff',
      padding: '4px 8px',
      borderRadius: '12px',
      border: '1px solid #c7d2fe'
    },
    loaderContainer: {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(248, 250, 252, 0.95)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: '1000'
    },
    loaderCard: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '32px 40px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      border: '1px solid #e2e8f0',
      minWidth: '300px',
      textAlign: 'center'
    },
    loaderSpinner: {
      width: '48px',
      height: '48px',
      marginBottom: '16px'
    },
    loaderText: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '8px'
    },
    loaderSubtext: {
      fontSize: '14px',
      fontWeight: '400',
      color: '#6b7280',
      lineHeight: '1.5'
    },
    paginationContainer: {
      marginBottom: '8px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
      padding: '6px',
      backgroundColor: '#ffffff',
      borderRadius: '4px',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
      border: '1px solid #e2e8f0'
    },
    paginationButton: {
      padding: '4px 8px',
      border: '1px solid #e2e8f0',
      backgroundColor: '#ffffff',
      color: '#374151',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '11px',
      fontWeight: '500',
      transition: 'all 0.2s ease-in-out',
      outline: 'none',
      minWidth: '32px'
    },
    paginationButtonActive: {
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      borderColor: '#3b82f6',
      boxShadow: '0 2px 4px -1px rgba(59, 130, 246, 0.3)'
    },
    paginationInfo: {
      marginLeft: '8px',
      fontSize: '10px',
      color: '#6b7280',
      fontWeight: '500'
    },
    tableContainer: {
      backgroundColor: '#ffffff',
      borderRadius: '6px',
      overflow: 'hidden',
      boxShadow: '0 2px 4px -1px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e2e8f0'
    },
    tableScroll: {
      overflowX: 'auto',
      overflowY: 'auto',
      maxHeight: '61vh'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '13px',
      backgroundColor: '#ffffff'
    },
    tableHeader: {
      backgroundColor: '#f8fafc',
      color: '#374151',
      fontWeight: '600',
      fontSize: '12px',
      textTransform: 'uppercase',
      letterSpacing: '0.3px',
      position: 'sticky',
      top: '0',
      zIndex: '10'
    },
    tableHeaderCell: {
      padding: '8px 6px',
      textAlign: 'left',
      borderBottom: '1px solid #e2e8f0',
      borderRight: '1px solid #f1f5f9',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out'
    },
    sortHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px'
    },
    sortIcons: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0px'
    },
    sortIcon: {
      fontSize: '12px',
      color: '#94a3b8',
      transition: 'color 0.2s ease-in-out'
    },
    sortIconActive: {
      color: '#3b82f6'
    },
    tableRow: {
      transition: 'background-color 0.2s ease-in-out',
      borderBottom: '1px solid #f1f5f9'
    },
    tableCell: {
      padding: '7px 5px',
      textAlign: 'left',
      borderRight: '1px solid #f8fafc',
      wordWrap: 'break-word',
      maxWidth: '160px',
      fontSize: '12px'
    },
    stickyColumn: {
      position: 'sticky',
      backgroundColor: '#f8fafc',
      zIndex: '5',
      borderLeft: '2px solid #3b82f6',
      borderRight: '2px solid #3b82f6',
      boxShadow: '-2px 0 4px rgba(0, 0, 0, 0.1), 2px 0 4px rgba(0, 0, 0, 0.1)',
      fontWeight: '600',
      minWidth: '75px',
      textAlign: 'center',
      fontSize: '11px',
      padding: '6px 4px'
    },
    stickyColumnHeader: {
      position: 'sticky',
      backgroundColor: '#e2e8f0',
      zIndex: '10',
      borderLeft: '2px solid #3b82f6',
      borderRight: '2px solid #3b82f6',
      boxShadow: '-2px 0 4px rgba(0, 0, 0, 0.15), 2px 0 4px rgba(0, 0, 0, 0.15)',
      fontWeight: '700',
      minWidth: '75px',
      textAlign: 'center',
      background: 'linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)',
      fontSize: '11px',
      padding: '7px 4px'
    },
    noData: {
      textAlign: 'center',
      padding: '40px 20px',
      color: '#6b7280',
      fontSize: '16px',
      fontWeight: '500',
      fontStyle: 'italic'
    }
  };

  const userId = localStorage.getItem("userId");
  const formattedFromDateForAPI = fromDate ? formatDateForAPI(fromDate) : "";
  const formattedToDateForAPI = toDate ? formatDateForAPI(toDate) : "";
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: null
  });

  // Date validation function for 75 days maximum
  const validateDateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return true; // Allow empty dates
    
    const daysDiff = endDate.diff(startDate, 'day');
    return daysDiff >= 0 && daysDiff <= 75; // Maximum 75 days range
  };

  // Update date range validation when dates change
  useEffect(() => {
    const isValid = validateDateRange(fromDate, toDate);
    setIsDateRangeValid(isValid);
  }, [fromDate, toDate]);

  const sortData = (data, key, direction) => {
    if (!key || !direction) return data;

    return [...data].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      // Handle special cases for formatted dates
      if (key === "orderDate" || key === "billingDateTime" || 
          key === "deliveryScheduleDate" || key === "pickUpDateTime" || 
          key === "deliveryDateTime") {
        aValue = new Date(a[key]);
        bValue = new Date(b[key]);
      }
      
      // Handle numeric values
      if (key === "totalAmount") {
        aValue = getTotalAmountFromItemsum(a);
        bValue = getTotalAmountFromItemsum(b);
      }

      if (aValue === bValue) return 0;
      
      if (direction === "ascending") {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });
  };

  // Handle sort
  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    } else if (sortConfig.key === key && sortConfig.direction === "descending") {
      direction = null;
    }
    setSortConfig({ key, direction });
  };

  // Sort header component
  const SortHeader = ({ column, label }) => {
    return (
      <th 
        onClick={() => handleSort(column)}
        style={{
          ...styles.tableHeaderCell,
          cursor: 'pointer'
        }}
      >
        <div style={styles.sortHeader}>
          {label}
          <div style={styles.sortIcons}>
            <ArrowDropUpIcon 
              style={{
                ...styles.sortIcon,
                ...(sortConfig.key === column && sortConfig.direction === "ascending" ? styles.sortIconActive : {})
              }}
            />
            <ArrowDropDownIcon 
              style={{
                ...styles.sortIcon,
                ...(sortConfig.key === column && sortConfig.direction === "descending" ? styles.sortIconActive : {})
              }}
            />
          </div>
        </div>
      </th>
    );
  };

  // Calculate pagination values
  useEffect(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    setDisplayData(filteredData.slice(indexOfFirstRecord, indexOfLastRecord));
  }, [currentPage, filteredData]);

  // Effect to apply sorting and update filtered data
  useEffect(() => {
    if (ledgerData.length > 0) {
      const sortedData = sortData(ledgerData, sortConfig.key, sortConfig.direction);
      setFilteredData(sortedData);
      setCurrentPage(1); // Reset to first page after sorting
    }
  }, [sortConfig, ledgerData]);

  const API_URL = `${local_url}/api/EcommOrderMovementReport/getLedgerListing/ALL/ECOMORDER/ALL/ALL/${selectedSfAreaId || "ALL"}/${formattedFromDateForAPI}/${formattedToDateForAPI}`;

  const fetchLedgerData = async () => {
    setLoading(true);
    setFetchingData(true);
    setError(null);
    setHasSubmittedData(false); // Reset submission flag

    try {
      const token = localStorage.getItem('AuthorizationToken');
      if (!token) {
        setError("Authorization token is missing. Please log in again.");
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
        return;
      }

      // Make API call with Authorization header
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 401) {
        console.error("Session expired or invalid token.");
        localStorage.clear();
        sessionStorage.clear();
        alert("Session expired. Please log in again.");
        window.location.href = "/login";
        return;
      }

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      // Parse response data
      const data = await response.json();
      console.log(`Fetched ${data.length} records`);
      setLedgerData(data);
      setFilteredData(data);
      setHasSubmittedData(true); // Mark as successfully submitted with data
    } catch (error) {
      console.error("Error fetching ledger data:", error);
      setError("Failed to fetch ledger data. Please try again later.");
    } finally {
      setLoading(false);
      setFetchingData(false);
    }
  };

  const fetchSfAreas = async () => {
    try {
      const response = await fetch(`${local_url}/api/SFArea/${userId}`);
      if (!response.ok) throw new Error("Failed to fetch SF Areas");
      const data = await response.json();
      setSfAreas(data);
    } catch (error) {
      setError("Failed to fetch SF Areas. Please try again later.");
    }
  };

  const fetchPaymentGateways = async () => {
    try {
      const token = localStorage.getItem('AuthorizationToken');
      const branchId = selectedSfAreaId || "W001"; // Use selected area or default
      const response = await fetch(`${local_signage}/api/v1/branchpayment?BranchID=${branchId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) throw new Error("Failed to fetch Payment Gateways");
      const data = await response.json();
      setPaymentGateways(data);
    } catch (error) {
      console.error("Failed to fetch Payment Gateways:", error);
      setPaymentGateways([]);
    }
  };

  // const fetchBusinessChannels = async () => {
  //   try {
  //     const response = await fetch(`${local_signage}/api/v1/fetchbusinesschanneltype`);
  //     if (!response.ok) throw new Error("Failed to fetch Business Channels");
  //     const data = await response.json();
  //     setBusinessChannels(data);
  //   } catch (error) {
  //     setError("Failed to fetch Business Channels. Please try again later.");
  //   }
  // };

  const formatDateTime = (dateTime, formatType) => {
    if (dateTime === "1753-01-01T00:00:00" || !dateTime) return "-";
    const date = new Date(dateTime);
    if (formatType === "date") {
      return `${String(date.getDate()).padStart(2, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}-${date.getFullYear()}`;
    }
    if (formatType === "time") {
      return `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}`;
    }
    return "-";
  };

  // Function to get total amount from item
  const getTotalAmountFromItemsum = (item) => {
    // For this API, totalAmount is directly available in the item object
    // Handle null, undefined, empty string, and ensure it's a valid number
    if (item.totalAmount === null || item.totalAmount === undefined || item.totalAmount === '') {
      return 0;
    }
    const amount = parseFloat(item.totalAmount);
    return isNaN(amount) ? 0 : amount;
  };

  // Function to get delivery charge from item
  const getDeliveryCharge = (item) => {
    // Check if deliveryCharge field exists in the API response
    if (item.deliveryCharge !== null && item.deliveryCharge !== undefined && item.deliveryCharge !== '') {
      const charge = parseFloat(item.deliveryCharge);
      return isNaN(charge) ? 0 : charge;
    }
    // If deliveryCharge field doesn't exist, return 0 (can be updated based on actual API field)
    return 0;
  };

  // Function to calculate order amount (Total Amount - Delivery Charge)
  const getOrderAmount = (item) => {
    const totalAmount = getTotalAmountFromItemsum(item);
    const deliveryCharge = getDeliveryCharge(item);
    return totalAmount - deliveryCharge;
  };

  // Function to parse time slot (e.g., "09:00 AM - 10:30 AM")
  const parseTimeSlot = (timeSlot) => {
    if (!timeSlot || timeSlot === "-" || timeSlot === "NA") {
      return { start: null, end: null };
    }
    
    try {
      const [startStr, endStr] = timeSlot.split(" - ");
      if (!startStr || !endStr) return { start: null, end: null };
      
      const parseTime = (timeStr) => {
        const [time, period] = timeStr.trim().split(" ");
        const [hours, minutes] = time.split(":");
        let hour24 = parseInt(hours);
        
        if (period === "PM" && hour24 !== 12) hour24 += 12;
        if (period === "AM" && hour24 === 12) hour24 = 0;
        
        return { hours: hour24, minutes: parseInt(minutes) || 0 };
      };
      
      const start = parseTime(startStr);
      const end = parseTime(endStr);
      
      return { start, end };
    } catch (error) {
      return { start: null, end: null };
    }
  };

  // Function to calculate delivery time duration (delivery date time - pickup date time)
  const calculateDeliveryDuration = (deliveryDateTime, pickUpDateTime) => {
    // Check if we have valid delivery and pickup times
    if (!deliveryDateTime || deliveryDateTime === "1753-01-01T00:00:00" ||
        !pickUpDateTime || pickUpDateTime === "1753-01-01T00:00:00") {
      return "N/A";
    }

    try {
      const deliveryDate = new Date(deliveryDateTime);
      const pickupDate = new Date(pickUpDateTime);
      
      // Check if dates are valid
      if (isNaN(deliveryDate.getTime()) || isNaN(pickupDate.getTime())) {
        return "N/A";
      }
      
      // Calculate difference in milliseconds
      const diffMs = deliveryDate - pickupDate;
      
      // If negative duration (pickup after delivery), return N/A
      if (diffMs < 0) {
        return "N/A";
      }
      
      // Convert to minutes, hours, and days
      const diffMinutes = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMinutes / 60);
      const diffDays = Math.floor(diffHours / 24);
      
      // Format the duration based on the time span
      if (diffDays > 0) {
        const remainingHours = diffHours % 24;
        const remainingMinutes = diffMinutes % 60;
        if (remainingHours > 0 && remainingMinutes > 0) {
          return `${diffDays}d ${remainingHours}h ${remainingMinutes}m`;
        } else if (remainingHours > 0) {
          return `${diffDays}d ${remainingHours}h`;
        } else if (remainingMinutes > 0) {
          return `${diffDays}d ${remainingMinutes}m`;
        } else {
          return `${diffDays}d`;
        }
      } else if (diffHours > 0) {
        const remainingMinutes = diffMinutes % 60;
        if (remainingMinutes > 0) {
          return `${diffHours}h ${remainingMinutes}m`;
        } else {
          return `${diffHours}h`;
        }
      } else {
        return `${diffMinutes}m`;
      }
    } catch (error) {
      console.error("Error calculating delivery duration:", error);
      return "N/A";
    }
  };

  // Function to calculate if delivery is delayed
  const calculateDelayStatus = (deliveryDateTime, timeSlot, deliveryScheduleDate) => {
    // Check if we have valid delivery date and time
    if (!deliveryDateTime || deliveryDateTime === "1753-01-01T00:00:00") {
      return { delayed: "NA", delayedBy: "No delivery time" };
    }

    // Parse time slot
    const { start, end } = parseTimeSlot(timeSlot);
    if (!start || !end) {
      return { delayed: "NA", delayedBy: "Invalid time slot" };
    }

    // Create delivery date object
    const deliveryDate = new Date(deliveryDateTime);
    const scheduleDate = new Date(deliveryScheduleDate);
    
    // Check if delivery was on the scheduled date
    const isSameDate = deliveryDate.toDateString() === scheduleDate.toDateString();
    
    if (!isSameDate) {
      // Calculate days difference
      const daysDiff = Math.floor((deliveryDate - scheduleDate) / (1000 * 60 * 60 * 24));
      if (daysDiff > 0) {
        return { delayed: "Yes", delayedBy: `${daysDiff} day(s)` };
      } else if (daysDiff < 0) {
        return { delayed: "No", delayedBy: "Early delivery" };
      }
    }

    // Create time objects for the scheduled date
    const endTimeScheduled = new Date(scheduleDate);
    endTimeScheduled.setHours(end.hours, end.minutes, 0, 0);

    // Compare delivery time with end of time slot
    if (deliveryDate > endTimeScheduled) {
      // Calculate delay in minutes
      const delayMinutes = Math.floor((deliveryDate - endTimeScheduled) / (1000 * 60));
      
      if (delayMinutes < 1) {
        return { delayed: "No", delayedBy: "On time" };
      } else if (delayMinutes >= 60) {
        const hours = Math.floor(delayMinutes / 60);
        const mins = delayMinutes % 60;
        return { 
          delayed: "Yes", 
          delayedBy: mins > 0 ? `${hours}h ${mins}m` : `${hours}h`
        };
      } else {
        return { delayed: "Yes", delayedBy: `${delayMinutes}m` };
      }
    } else {
      return { delayed: "No", delayedBy: "On time" };
    }
  };

  const handleSfAreaChange = (event) => {
    setSelectedSfAreaId(event.target.value);
  };

  const handleChannelTypeChange = (event) => {
    setSelectedChannelType(event.target.value);
  };

  // Function to escape CSV values properly
  const escapeCSV = (value) => {
    if (value == null || value === undefined) return '""';
    const stringValue = String(value);
    // If the value contains quotes, commas, or newlines, wrap in quotes and escape quotes
    if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
      return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
  };

  const exportToCSV = async () => {
    if (filteredData.length === 0) {
      alert("No data to export");
      return;
    }

    setExportLoading(true);

    try {
      // Define headers for the Excel file with enhanced columns
      const headers = [
        "Sr.No",
        "Sale Order ID",
        "Order Date",
        "Order Time",
        "Current Status",
        "Promo Code",
        "POS Bill Number",
        "Billing Branch",
        "Billing Date",
        "Billing Time",
        "Delivery Schedule Date",
        "Schedule Time Slot",
        "Laziz CustId",
        "POS CustId",
        "Customer Mobile",
        "Customer Name",
        "Customer Address",
        "Area",
        "Pincode",
        "Manager Name",
        "WooComm Status",
        "Delivery Branch ID",
        "Order Amount (₹)",
        "Delivery Charge (₹)",
        "Total Amount (₹)",
        "Delivery By",
        "Pickup Date",
        "Pickup Time",
        "Delivery Date",
        "Delivery Time",
        "Delivery Duration",
        "Delayed Status",
        "Delayed By (Hours)",
        "Payment Mode",
        "RRN Number",
      ];

      const rows = [];

      // Process data in chunks to prevent browser from freezing
      const chunkSize = 500;
      for (let i = 0; i < filteredData.length; i += chunkSize) {
        const chunk = filteredData.slice(i, i + chunkSize);
        for (let j = 0; j < chunk.length; j++) {
          const item = chunk[j];
          const index = i + j;

          // Prepare dates in DD-MM-YYYY format
          const formatDateDD = (dateStr) => {
            if (!dateStr || dateStr === "1753-01-01T00:00:00") return "-";
            const date = new Date(dateStr);
            return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
          };

          const orderDate = formatDateDD(item.orderDate);
          const orderTime = formatDateTime(item.orderDate, "time");
          const billingDate = formatDateDD(item.billingDateTime);
          const billingTime = formatDateTime(item.billingDateTime, "time");
          const scheduleDate = formatDateDD(item.deliveryScheduleDate);
          const deliveryDate = formatDateDD(item.deliveryDateTime);
          const deliveryTime = formatDateTime(item.deliveryDateTime, "time");
          const pickupDate = formatDateDD(item.pickUpDateTime);
          const pickupTime = formatDateTime(item.pickUpDateTime, "time");
          const delayStatus = calculateDelayStatus(item.deliveryDateTime, item.timeSlotName, item.deliveryScheduleDate);
          const deliveryDuration = calculateDeliveryDuration(item.deliveryDateTime, item.pickUpDateTime);

          // Get amounts with proper fallback and formatting
          const totalAmount = getTotalAmountFromItemsum(item);
          const deliveryCharge = getDeliveryCharge(item);
          const orderAmount = getOrderAmount(item);

          const formattedTotalAmount = totalAmount ? parseFloat(totalAmount).toFixed(2) : "0.00";
          const formattedDeliveryCharge = deliveryCharge ? parseFloat(deliveryCharge).toFixed(2) : "0.00";
          const formattedOrderAmount = orderAmount ? parseFloat(orderAmount).toFixed(2) : "0.00";

          rows.push([
            index + 1,
            item.saleOrderID || "-",
            orderDate,
            orderTime,
            item.systemStatus || "-",
            item.promoCodes || "-",
            item.saleId ? parseInt(item.saleId, 10) : "-",
            item.saleBranchId || "-",
            billingDate,
            billingTime,
            scheduleDate,
            item.timeSlotName || "-",
            item.lazizCustID || "-",
            item.retailCustID || "-",
            item.mobile || "-",
            item.customerName || "-",
            item.customerAddress || "-",
            item.areaName || "-",
            item.pincode || "-",
            item.managerName || "-",
            item.wooCommStatus || "-",
            item.delBranchID || "-",
            formattedOrderAmount,
            formattedDeliveryCharge,
            formattedTotalAmount,
            item.deliveryBy || "-",
            pickupDate,
            pickupTime,
            deliveryDate,
            deliveryTime,
            deliveryDuration,
            delayStatus.delayed || "-",
            delayStatus.delayedBy || "-",
            item.payMode || "-",
            item.payMode && item.payMode.toLowerCase() === "prepaid" ? "-" : (item.authCode || "-"),
          ]);
        }
        await new Promise(resolve => setTimeout(resolve, 0));
      }

      // Create workbook and worksheet
      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Order Movement Report");

      // Enhanced column widths based on content
      const colWidths = [
        { wch: 8 },  // Sr.No
        { wch: 18 }, // Sale Order ID
        { wch: 12 }, // Order Date
        { wch: 10 }, // Order Time
        { wch: 15 }, // Current Status
        { wch: 12 }, // Promo Code
        { wch: 15 }, // POS Bill Number
        { wch: 15 }, // Billing Branch
        { wch: 12 }, // Billing Date
        { wch: 10 }, // Billing Time
        { wch: 18 }, // Delivery Schedule Date
        { wch: 20 }, // Schedule Time Slot
        { wch: 12 }, // Laziz CustId
        { wch: 12 }, // POS CustId
        { wch: 15 }, // Customer Mobile
        { wch: 25 }, // Customer Name
        { wch: 40 }, // Customer Address
        { wch: 20 }, // Area
        { wch: 10 }, // Pincode
        { wch: 20 }, // Manager Name
        { wch: 15 }, // WooComm Status
        { wch: 15 }, // Delivery Branch ID
        { wch: 15 }, // Order Amount
        { wch: 15 }, // Delivery Charge
        { wch: 15 }, // Total Amount
        { wch: 15 }, // Delivery By
        { wch: 12 }, // Pickup Date
        { wch: 10 }, // Pickup Time
        { wch: 12 }, // Delivery Date
        { wch: 10 }, // Delivery Time
        { wch: 15 }, // Delivery Duration
        { wch: 12 }, // Delayed Status
        { wch: 18 }, // Delayed By
        { wch: 15 }, // Payment Mode
        { wch: 15 }, // RRN Number
      ];
      ws['!cols'] = colWidths;

      // Format the amount columns as numbers with 2 decimals
      const orderAmountColIndex = 22; // Column index for Order Amount (0-based)
      const deliveryChargeColIndex = 23; // Column index for Delivery Charge (0-based)
      const totalAmountColIndex = 24; // Column index for Total Amount (0-based)

      for (let i = 1; i <= rows.length; i++) {
        // Format Order Amount
        const orderAmountCell = XLSX.utils.encode_cell({ r: i, c: orderAmountColIndex });
        if (ws[orderAmountCell]) {
          ws[orderAmountCell].t = 'n';
          ws[orderAmountCell].v = parseFloat(ws[orderAmountCell].v) || 0;
          ws[orderAmountCell].z = '#,##0.00';
        }

        // Format Delivery Charge
        const deliveryChargeCell = XLSX.utils.encode_cell({ r: i, c: deliveryChargeColIndex });
        if (ws[deliveryChargeCell]) {
          ws[deliveryChargeCell].t = 'n';
          ws[deliveryChargeCell].v = parseFloat(ws[deliveryChargeCell].v) || 0;
          ws[deliveryChargeCell].z = '#,##0.00';
        }

        // Format Total Amount
        const totalAmountCell = XLSX.utils.encode_cell({ r: i, c: totalAmountColIndex });
        if (ws[totalAmountCell]) {
          ws[totalAmountCell].t = 'n';
          ws[totalAmountCell].v = parseFloat(ws[totalAmountCell].v) || 0;
          ws[totalAmountCell].z = '#,##0.00';
        }
      }

      // Generate the Excel file
      XLSX.writeFile(wb, `order_movement_report_${fromDate ? fromDate.format('DD-MM-YYYY') : ''}_to_${toDate ? toDate.format('DD-MM-YYYY') : ''}.xlsx`);

    } catch (error) {
      console.error("Error generating Excel file:", error);
      alert("Failed to export data. Please try again.");
    } finally {
      setExportLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = ledgerData;

    // Apply search filter
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter((item) =>
        (item.saleOrderID && item.saleOrderID.toLowerCase().includes(query)) ||
        (item.saleId && item.saleId.toLowerCase().includes(query))
      );
    }

    // Apply delay filter
    if (delayFilter !== "ALL") {
      filtered = filtered.filter((item) => {
        const delayStatus = calculateDelayStatus(item.deliveryDateTime, item.timeSlotName, item.deliveryScheduleDate);
        return delayStatus.delayed === delayFilter;
      });
    }

    // Apply payment mode filter
    if (selectedPaymentModes.length > 0) {
      filtered = filtered.filter((item) =>
        selectedPaymentModes.includes(item.payMode)
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page when filtering
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  const handleDelayFilterChange = (event) => {
    setDelayFilter(event.target.value);
  };

  const handlePaymentModeChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedPaymentModes([...selectedPaymentModes, value]);
    } else {
      setSelectedPaymentModes(selectedPaymentModes.filter((mode) => mode !== value));
    }
  };

  const handleClearPaymentModes = () => {
    setSelectedPaymentModes([]);
  };

  // Expandable Address Component
  const ExpandableAddress = ({ address, maxLength = 50 }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    
    if (!address || address === '-' || address === 'NA') {
      return <span>-</span>;
    }
    
    const shouldTruncate = address.length > maxLength;
    const displayAddress = isExpanded || !shouldTruncate 
      ? address 
      : `${address.substring(0, maxLength)}...`;
    
    return (
      <div style={{ maxWidth: '300px', wordWrap: 'break-word' }}>
        <span>{displayAddress}</span>
        {shouldTruncate && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            style={{
              marginLeft: '5px',
              padding: '2px 6px',
              fontSize: '11px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#0056b3';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#007bff';
            }}
          >
            {isExpanded ? 'less' : 'more...'}
          </button>
        )}
      </div>
    );
  };

  // Apply filters whenever search query, delay filter, or payment mode changes
  useEffect(() => {
    applyFilters();
  }, [searchQuery, delayFilter, selectedPaymentModes, ledgerData]);

  useEffect(() => {
    fetchSfAreas();
    fetchPaymentGateways();
    // fetchBusinessChannels();
  }, []);

  const handleSubmit = () => {
    if (!selectedSfAreaId || selectedSfAreaId === "") {
      alert('Please select an Area.');
      return;
    }

    // if (!selectedChannelType || selectedChannelType === "") {
    //   alert('Please select a Channel Type.');
    //   return;
    // }

    if (!fromDate || !toDate) {
      alert('Please select both From Date and To Date.');
      return;
    }

    if (fromDate.isAfter(toDate)) {
      alert('From Date cannot be after To Date.');
      return;
    }

    if (!isDateRangeValid) {
      alert('Date range cannot exceed 75 days. Please select a smaller date range.');
      return;
    }

    fetchLedgerData();
  };

  // Pagination controls
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);
  const pageNumbers = [];
  
  // Calculate which page numbers to show
  const maxPageButtons = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
  let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
  
  if (endPage - startPage + 1 < maxPageButtons) {
    startPage = Math.max(1, endPage - maxPageButtons + 1);
  }
  
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Custom styles for date pickers with conditional red border
  const getDatePickerStyle = (isValid = true) => ({
    width: '100%',
    minWidth: '180px',
    '& .MuiInputBase-root': {
      height: '40px',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: isValid ? '#ccc' : '#f44336', // Red border when invalid
      },
      '&:hover fieldset': {
        borderColor: isValid ? '#999' : '#f44336',
      },
      '&.Mui-focused fieldset': {
        borderColor: isValid ? '#1976d2' : '#f44336',
      },
    },
    '& .MuiInputLabel-root': {
      color: isValid ? 'rgba(0, 0, 0, 0.6)' : '#f44336', // Red label when invalid
    },
  });

  // Legacy date picker style for From Date (always valid styling)
  const datePickerStyle = getDatePickerStyle();

  return (
    <>
      <Header />
      <div style={styles.container}>
        {error && <div style={styles.errorMessage}>{error}</div>}
        <div style={styles.inputContainer}>
          <select
            style={styles.dropdown}
            value={selectedSfAreaId}
            onChange={handleSfAreaChange}
          >
            <option value="" disabled>
              Select Area 
            </option>
            <option value="ALL">ALL</option>
            {sfAreas.map((area) => (
              <option key={area.sfAreaId} value={area.sfAreaId}>
                {area.sfAreaName} ({area.sfAreaId})
              </option>
            ))}
          </select>
{/* 
          <select
            className="customer-dropdown"
            value={selectedChannelType}
            onChange={handleChannelTypeChange}
          >
            <option value="" disabled>
              Select Channel Type
            </option>
            <option value="ALL">ALL</option>
            {businessChannels.map((channel) => (
              <option key={channel.ChannelType} value={channel.ChannelType}>
                {channel.ChannelTypeName}
              </option>
            ))}
          </select> */}

          <div style={styles.datePickerContainer}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={(newValue) => setFromDate(newValue)}
                format="DD-MM-YYYY"
                sx={datePickerStyle}
                slotProps={{
                  textField: {
                    size: "small",
                    variant: "outlined"
                  }
                }}
              />
            </LocalizationProvider>
            {!isDateRangeValid && (
              <div style={{ 
                fontSize: '12px', 
                color: '#f44336', 
                marginTop: '4px',
                fontWeight: '500'
              }}>
                Date range cannot exceed 75 days
              </div>
            )}
          </div>

          <div style={{ margin: '3px' }}>
            <span>-</span>
          </div>

          <div style={styles.datePickerContainer}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                format="DD-MM-YYYY"
                sx={getDatePickerStyle(isDateRangeValid)}
                slotProps={{
                  textField: {
                    size: "small",
                    variant: "outlined"
                  }
                }}
              />
            </LocalizationProvider>
            {!isDateRangeValid && (
              <div style={{ 
                fontSize: '12px', 
                color: '#f44336', 
                marginTop: '4px',
                fontWeight: '500'
              }}>
                {fromDate && toDate ? 
                  `Range: ${toDate.diff(fromDate, 'day')} days (max 75 days allowed)` :
                  'Date range cannot exceed 75 days'
                }
              </div>
            )}
          </div>

          <button
            onClick={handleSubmit}
            style={{
              ...styles.submitButton,
              opacity: (loading || !selectedSfAreaId ||  !isDateRangeValid) ? 0.6 : 1,
              cursor: (loading || !selectedSfAreaId || !isDateRangeValid) ? 'not-allowed' : 'pointer'
            }}
            disabled={loading || !selectedSfAreaId || !isDateRangeValid}
          >
            {fetchingData ? "Loading..." : "Submit"}
          </button>
          <button
            onClick={exportToCSV}
            style={{
              ...styles.exportButton,
              opacity: (loading || !hasSubmittedData || filteredData.length === 0 || exportLoading || !isDateRangeValid ) ? 0.6 : 1,
              cursor: (loading || !hasSubmittedData || filteredData.length === 0 || exportLoading || !isDateRangeValid ) ? 'not-allowed' : 'pointer'
            }}
            disabled={loading || !hasSubmittedData || filteredData.length === 0 || exportLoading || !isDateRangeValid }
          >
            {exportLoading ? "Exporting..." : "Export to CSV"}
          </button>
        </div>

        {/* Search Bar, Delay Filter, Payment Mode Filter and Data Count */}
        <div style={styles.searchContainer}>
          <input
            type="text"
            placeholder="Search Sale Order ID or POS Bill Number"
            value={searchQuery}
            onChange={handleSearch}
            style={styles.searchInput}
          />
          <select
            value={delayFilter}
            onChange={handleDelayFilterChange}
            style={styles.dropdown}
          >
            <option value="ALL">All Deliveries</option>
            <option value="Yes">Delayed</option>
            <option value="No">On Time</option>
            <option value="NA">No Data</option>
          </select>

          {/* Payment Mode Multiselect Dropdown */}
          <div style={{
            position: 'relative',
            display: 'inline-block',
            minWidth: '180px'
          }}>
            <button
              style={{
                ...styles.dropdown,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                minWidth: '180px',
                cursor: 'pointer',
                backgroundColor: selectedPaymentModes.length > 0 ? '#e3f2fd' : '#ffffff'
              }}
              onClick={(e) => {
                e.currentTarget.nextElementSibling.style.display =
                  e.currentTarget.nextElementSibling.style.display === 'block' ? 'none' : 'block';
              }}
            >
              <span>
                {selectedPaymentModes.length > 0
                  ? `${selectedPaymentModes.length} Payment Mode(s)`
                  : 'Payment Mode'}
              </span>
              <span>▼</span>
            </button>
            <div
              style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '4px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                zIndex: 1000,
                display: 'none',
                minWidth: '200px',
                maxHeight: '300px',
                overflowY: 'auto',
                padding: '8px 0'
              }}
            >
              {paymentGateways.length > 0 ? (
                <>
                  {/* ALL Option */}
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '8px 12px',
                      cursor: 'pointer',
                      backgroundColor: selectedPaymentModes.length === 0 ? '#f0f4ff' : 'transparent',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #e2e8f0',
                      fontWeight: '600'
                    }}
                    onMouseEnter={(e) => {
                      if (selectedPaymentModes.length > 0) {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedPaymentModes.length > 0) {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }
                    }}
                  >
                    <input
                      type="radio"
                      name="paymentMode"
                      value="ALL"
                      checked={selectedPaymentModes.length === 0}
                      onChange={() => handleClearPaymentModes()}
                      style={{
                        marginRight: '8px',
                        cursor: 'pointer',
                        width: '16px',
                        height: '16px'
                      }}
                    />
                    <span style={{ fontSize: '13px', color: '#374151' }}>
                      All Payment Modes
                    </span>
                  </label>

                  {/* Individual Payment Gateways */}
                  {paymentGateways.map((gateway) => (
                    <label
                      key={gateway.PaymentGatewayId}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 12px',
                        cursor: 'pointer',
                        backgroundColor: selectedPaymentModes.includes(gateway.PaymentGatewayName)
                          ? '#f0f4ff'
                          : 'transparent',
                        transition: 'background-color 0.2s ease',
                        ':hover': {
                          backgroundColor: '#f5f5f5'
                        }
                      }}
                      onMouseEnter={(e) => {
                        if (!selectedPaymentModes.includes(gateway.PaymentGatewayName)) {
                          e.currentTarget.style.backgroundColor = '#f5f5f5';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!selectedPaymentModes.includes(gateway.PaymentGatewayName)) {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }
                      }}
                    >
                      <input
                        type="checkbox"
                        value={gateway.PaymentGatewayName}
                        checked={selectedPaymentModes.includes(gateway.PaymentGatewayName)}
                        onChange={handlePaymentModeChange}
                        style={{
                          marginRight: '8px',
                          cursor: 'pointer',
                          width: '16px',
                          height: '16px'
                        }}
                      />
                      <span style={{ fontSize: '13px', color: '#374151' }}>
                        {gateway.PaymentGatewayName}
                      </span>
                    </label>
                  ))}
                  {selectedPaymentModes.length > 0 && (
                    <button
                      onClick={handleClearPaymentModes}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderTop: '1px solid #e2e8f0',
                        backgroundColor: '#fef2f2',
                        color: '#dc2626',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '500',
                        transition: 'background-color 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#fee2e2';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#fef2f2';
                      }}
                    >
                      Clear All
                    </button>
                  )}
                </>
              ) : (
                <div style={{ padding: '12px', color: '#6b7280', fontSize: '13px' }}>
                  No payment modes available
                </div>
              )}
            </div>
          </div>

          {filteredData.length > 0 && (
            <div style={styles.dataCount}>
              Total Records: {filteredData.length}
            </div>
          )}
        </div>

        {/* Loading Indicator */}
{fetchingData && (
  <div style={styles.loaderContainer}>
    <div style={styles.loaderCard}>
      <CircularProgress 
        size={48}
        thickness={4}
        style={styles.loaderSpinner}
        sx={{
          color: '#3b82f6',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          }
        }}
      />
      <div style={styles.loaderText}>Loading Sale Order Data</div>
      <div style={styles.loaderSubtext}>
        Please wait while we fetch your data...
        <br />
        This may take a few moments.
      </div>
    </div>
  </div>
)}

        {/* Pagination Controls - Top */}
        {filteredData.length > recordsPerPage && (
          <div style={styles.paginationContainer}>
            <button 
              onClick={() => paginate(1)} 
              disabled={currentPage === 1}
              style={{
                ...styles.paginationButton,
                opacity: currentPage === 1 ? 0.5 : 1,
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
              }}
            >
              First
            </button>
            <button 
              onClick={() => paginate(currentPage - 1)} 
              disabled={currentPage === 1}
              style={{
                ...styles.paginationButton,
                opacity: currentPage === 1 ? 0.5 : 1,
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
              }}
            >
              Prev
            </button>
            
            {pageNumbers.map(number => (
              <button
                key={number}
                onClick={() => paginate(number)}
                style={{
                  ...styles.paginationButton,
                  ...(currentPage === number ? styles.paginationButtonActive : {})
                }}
              >
                {number}
              </button>
            ))}
            
            <button 
              onClick={() => paginate(currentPage + 1)} 
              disabled={currentPage === totalPages}
              style={{
                ...styles.paginationButton,
                opacity: currentPage === totalPages ? 0.5 : 1,
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
              }}
            >
              Next
            </button>
            <button 
              onClick={() => paginate(totalPages)} 
              disabled={currentPage === totalPages}
              style={{
                ...styles.paginationButton,
                opacity: currentPage === totalPages ? 0.5 : 1,
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
              }}
            >
              Last
            </button>
            <span style={styles.paginationInfo}>
              Page {currentPage} of {totalPages}
            </span>
          </div>
        )}

        <div style={styles.tableContainer}>
          <div style={styles.tableScroll}>
            <table style={styles.table}>
              <thead style={styles.tableHeader}>
                <tr>
                  <th style={styles.tableHeaderCell}>Sr.No</th>
                  <SortHeader column="saleOrderID" label="Sale Order ID" />
                  <SortHeader column="orderDate" label="Order Date" />
                  <SortHeader column="orderDate" label="Order Time" />
                  <SortHeader column="systemStatus" label="Current Status" />
                  <SortHeader column="promoCodes" label="Promo Codes" />
                  <SortHeader column="saleId" label="POS Bill Number" />
                  <SortHeader column="saleBranchId" label="Billing Branch" />
                  <SortHeader column="billingDateTime" label="Billing Date" />
                  <SortHeader column="billingDateTime" label="Billing Time" />
                  <SortHeader column="deliveryScheduleDate" label="Schedule Date" />
                  <SortHeader column="timeSlotName" label="Schedule Time Slot" />
                  <SortHeader column="lazizcustomerId" label="Laziz CustID" />
                  <SortHeader column="customerId" label="POS CustID" />
                  <SortHeader column="customerMobile" label="Customer Mobile" />
                  <SortHeader column="customerName" label="Customer Name" />
                  <SortHeader column="customerAddress" label="Customer Address" />
                  <SortHeader column="areaName" label="Area" />
                  <SortHeader column="pincode" label="Pincode" />
                  <SortHeader column="managerName" label="Manager Name" />
                  <SortHeader column="wooCommStatus" label="WooComm Status" />
                  <SortHeader column="delBranchID" label="Delivery Branch" />
                  <SortHeader column="totalAmount" label="Total Amount" />
                  <SortHeader column="deliveryBy" label="Delivery By" />
                  <SortHeader column="pickUpDateTime" label="Pickup Date" />
                  <SortHeader column="pickUpDateTime" label="Pickup Time" />
                  <SortHeader column="deliveryDateTime" label="Delivery Date" />
                  <SortHeader column="deliveryDateTime" label="Delivery Time" />
                  <SortHeader column="payMode" label="Payment Mode" />
                  <SortHeader column="authCode" label="RRN Number" />
                  <th style={{...styles.tableHeaderCell, ...styles.stickyColumnHeader, right: '150px', minWidth: '75px'}}>Duration</th>
                  <th style={{...styles.tableHeaderCell, ...styles.stickyColumnHeader, right: '75px', minWidth: '75px'}}>Status</th>
                  <th style={{...styles.tableHeaderCell, ...styles.stickyColumnHeader, right: '0px', minWidth: '75px'}}>Delayed By</th>
                </tr>
              </thead>
              <tbody>
                {displayData.length > 0 ? (
                  displayData.map((item, index) => {
                    const actualIndex = (currentPage - 1) * recordsPerPage + index;
                    const delayStatus = calculateDelayStatus(item.deliveryDateTime, item.timeSlotName, item.deliveryScheduleDate);
                    const deliveryDuration = calculateDeliveryDuration(item.deliveryDateTime, item.pickUpDateTime);
                    return (
                      <tr key={index} style={styles.tableRow}>
                        <td style={styles.tableCell}>{actualIndex + 1}</td>
                        <td style={styles.tableCell}>{item.saleOrderID || "-"}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.orderDate, "date")}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.orderDate, "time")}</td>
                        <td style={styles.tableCell}>{item.systemStatus || "-"}</td>
                        <td style={styles.tableCell}>{item.promoCodes || "-"}</td>                       
                        <td style={styles.tableCell}>{item.saleId ? parseInt(item.saleId, 10) : "-"}</td>
                        <td style={styles.tableCell}>{item.saleBranchId || "-"}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.billingDateTime, "date")}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.billingDateTime, "time")}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.deliveryScheduleDate, "date")}</td>
                        <td style={styles.tableCell}>{item.timeSlotName || "-"}</td>
                        <td style={styles.tableCell}>{item.lazizCustID || "-"}</td>
                        <td style={styles.tableCell}>{item.retailCustID || "-"}</td>
                        <td style={styles.tableCell}>{item.mobile || "-"}</td>
                        <td style={styles.tableCell}>{item.customerName || "-"}</td>
                        <td style={styles.tableCell}><ExpandableAddress address={item.customerAddress} /></td>
                        <td style={styles.tableCell}>{item.areaName || "-"}</td>
                        <td style={styles.tableCell}>{item.pincode || "-"}</td>
                        <td style={styles.tableCell}>{item.managerName || "-"}</td>
                        <td style={styles.tableCell}>{item.wooCommStatus || "-"}</td>
                        <td style={styles.tableCell}>{item.delBranchID || "-"}</td>
                        <td style={styles.tableCell}>₹{getTotalAmountFromItemsum(item).toFixed(2)}</td>
                        <td style={styles.tableCell}>{item.deliveryBy || "-"}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.pickUpDateTime, "date")}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.pickUpDateTime, "time")}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.deliveryDateTime, "date")}</td>
                        <td style={styles.tableCell}>{formatDateTime(item.deliveryDateTime, "time")}</td>
                        <td style={styles.tableCell}>{item.payMode || "-"}</td>
                        <td style={styles.tableCell}>{item.payMode && item.payMode.toLowerCase() === "prepaid" ? "-" : (item.authCode || "-")}</td>
                        <td style={{...styles.tableCell, ...styles.stickyColumn, right: '150px', minWidth: '75px'}}>{deliveryDuration}</td>
                        <td 
                          style={{ 
                            ...styles.tableCell, 
                            ...styles.stickyColumn, 
                            right: '75px',
                            minWidth: '75px',
                            color: delayStatus.delayed === 'Yes' ? '#dc2626' : delayStatus.delayed === 'No' ? '#059669' : '#d97706',
                            backgroundColor: delayStatus.delayed === 'Yes' ? '#fef2f2' : delayStatus.delayed === 'No' ? '#f0fdf4' : '#fffbeb',
                            fontWeight: '700',
                            fontSize: '10px'
                          }}
                        >
                          {delayStatus.delayed === 'Yes' ? '🔴 LATE' : delayStatus.delayed === 'No' ? '🟢 OK' : '🟡 N/A'}
                        </td>
                        <td style={{...styles.tableCell, ...styles.stickyColumn, right: '0px', minWidth: '75px'}}>{delayStatus.delayedBy}</td>
                      </tr>
                    );
                  })
                ) : fetchingData ? (
                  <tr>
                    <td colSpan="32" style={styles.noData}>
                      Loading data...
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="32" style={styles.noData}>
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>


      </div>

      {/* CSS for pagination and date picker */}
      <style>{`
        .pagination-container {
          margin: 15px 0;
        }
        .pagination-button {
          padding: 5px 10px;
          margin: 0 2px;
          border: 1px solid #ccc;
          background: #f5f5f5;
          cursor: pointer;
          color: black;
        }
        .pagination-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        .pagination-active {
          background: #007bff;
          color: white;
          border-color: #007bff;
        }
        .data-count {
          margin-left: 15px;
          font-weight: bold;
        }
        .loader-container {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 20px 0;
        }
        .date-picker-container {
          min-width: 180px;
          margin: 0 5px;
        }
        .customer-date-input-container {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 2px;
          margin-bottom: 20px;
        }
        
        /* Sticky columns */
        .sticky-duration-column {
          position: sticky !important;
          right: 200px !important;
          background: #F1F5F9 !important;
          border-left: 1px solid #ddd !important;
          z-index: 10 !important;
          min-width: 140px !important;
          text-align: center !important;
          font-weight: bold !important;
        }
        
        .sticky-delayed-column {
          position: sticky !important;
          right: 120px !important;
          background: #F1F5F9 !important;
          border-left: 1px solid #ddd !important;
          z-index: 10 !important;
          min-width: 80px !important;
          text-align: center !important;
          font-weight: bold !important;
        }
        
        .sticky-delayed-by-column {
          position: sticky !important;
          right: 0px !important;
          background: #F1F5F9 !important;
          border-left: 1px solid #ddd !important;
          z-index: 10 !important;
          min-width: 120px !important;
          text-align: center !important;
          font-weight: bold !important;
        }
        
        /* Header styling for sticky columns with shiny black-white gradient */
        thead .sticky-duration-column {
          background: linear-gradient(45deg, #4a4a4a 5%, #ffffff 10%,#004d00 75%, #000000 100%) !important;
          background-size: 200% 200% !important;
          animation: shine 3s ease-in-out infinite !important;
          color: white !important;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8) !important;
          font-weight: bold !important;
          position: sticky !important;
          right: 200px !important;
          z-index: 15 !important;
        }
        
        thead .sticky-delayed-column {
          background: linear-gradient(45deg, #4a4a4a 5%, #ffffff 10%,#004d00 75%, #000000 100%) !important;
          background-size: 200% 200% !important;
          animation: shine 3s ease-in-out infinite !important;
          color: white !important;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8) !important;
          font-weight: bold !important;
          position: sticky !important;
          right: 120px !important;
          z-index: 15 !important;
        }
        
        thead .sticky-delayed-by-column {
          background: linear-gradient(45deg, #4a4a4a 5%, #ffffff 5%,#004d00 75%, #000000 100%) !important;
          background-size: 200% 200% !important;
          animation: shine 3s ease-in-out infinite !important;
          color: white !important;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8) !important;
          font-weight: bold !important;
          position: sticky !important;
          right: 0px !important;
          z-index: 15 !important;
        }
        
        /* Shiny animation keyframes */
        @keyframes shine {
          0% { background-position: 0% 0%; }
          50% { background-position: 100% 100%; }
          100% { background-position: 0% 0%; }
        }
        
        @media (max-width: 768px) {
          .date-picker-container {
            width: 100%;
            margin: 5px 0;
          }
          .customer-date-input-container {
            flex-direction: column;
            align-items: stretch;
          }
          
          .sticky-duration-column {
            right: 160px !important;
            min-width: 100px !important;
            font-size: 12px !important;
          }
          
          .sticky-delayed-column {
            right: 100px !important;
            min-width: 60px !important;
            font-size: 12px !important;
          }
          
          .sticky-delayed-by-column {
            right: 0px !important;
            min-width: 100px !important;
            font-size: 12px !important;
          }
        }
      `}</style>
    </>
  );
};

export default SaleOrderReport;










































// import React, { useState, useEffect } from "react";
// import { Header } from "../Header";
// import CircularProgress from "@mui/material/CircularProgress";
// import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { local_signage, local_url } from "../Const";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import dayjs from 'dayjs';





// // Format date as YYYYMMDD for API
// const formatDateForAPI = (date) => {
//   if (!date) return "";
//   if (typeof date === 'string') {
//     const [year, month, day] = date.split('-');
//     return `${year}${month}${day}`;
//   }
//   // If it's a dayjs object
//   return date.format('YYYYMMDD');
// };

// export const SaleOrderReport = () => {
//   const today = dayjs();
//   const sixtyDaysAgo = today.subtract(30, 'day');

//   const [ledgerData, setLedgerData] = useState([]);
//   const [displayData, setDisplayData] = useState([]); // Data to be displayed (paginated)
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [fromDate, setFromDate] = useState(sixtyDaysAgo);
//   const [toDate, setToDate] = useState(today);
//   const [sfAreas, setSfAreas] = useState([]);
//   const [selectedSfAreaId, setSelectedSfAreaId] = useState("");
//   const [businessChannels, setBusinessChannels] = useState([]);
//   const [selectedChannelType, setSelectedChannelType] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [fetchingData, setFetchingData] = useState(false);
//   const [exportLoading, setExportLoading] = useState(false);
//   const [delayFilter, setDelayFilter] = useState("ALL");
  
//   // Date validation state
//   const [isDateRangeValid, setIsDateRangeValid] = useState(true);
//   const [hasSubmittedData, setHasSubmittedData] = useState(false);
  
//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const recordsPerPage = 100;

//   // Enhanced Styles Object
//   const styles = {
//     container: {
//       width: '100vw',
//       height: '90vh',
//       overflow: 'auto',
//       backgroundColor: '#f8fafc',
//       fontFamily: '"Inter", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
//       color: '#1e293b',
//       padding: '8px'
//     },
//     errorMessage: {
//       backgroundColor: '#fee2e2',
//       border: '1px solid #fecaca',
//       color: '#dc2626',
//       padding: '6px 10px',
//       borderRadius: '4px',
//       marginBottom: '8px',
//       fontSize: '12px',
//       fontWeight: '500',
//       boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
//     },
//     inputContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       marginBottom: '10px',
//       padding: '8px',
//       backgroundColor: '#ffffff',
//       borderRadius: '6px',
//       boxShadow: '0 2px 4px -1px rgba(0, 0, 0, 0.1)',
//       border: '1px solid #e2e8f0',
//       flexWrap: 'wrap'
//     },
//     dropdown: {
//       padding: '6px 8px',
//       border: '1px solid #e2e8f0',
//       borderRadius: '4px',
//       fontSize: '12px',
//       backgroundColor: '#ffffff',
//       color: '#374151',
//       cursor: 'pointer',
//       minWidth: '140px',
//       transition: 'all 0.2s ease-in-out',
//       outline: 'none',
//       appearance: 'none',
//       backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e")',
//       backgroundPosition: 'right 8px center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '12px',
//       paddingRight: '24px',
//       ':hover': {
//         borderColor: '#3b82f6',
//         boxShadow: '0 2px 4px -1px rgba(59, 130, 246, 0.1)'
//       }
//     },
//     datePickerContainer: {
//       position: 'relative',
//       display: 'flex',
//       flexDirection: 'column'
//     },
//     submitButton: {
//       padding: '6px 12px',
//       backgroundColor: '#3b82f6',
//       color: '#ffffff',
//       border: 'none',
//       borderRadius: '4px',
//       fontSize: '12px',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.2s ease-in-out',
//       boxShadow: '0 2px 4px -1px rgba(59, 130, 246, 0.3)',
//       outline: 'none',
//       minWidth: '80px'
//     },
//     exportButton: {
//       padding: '6px 12px',
//       backgroundColor: '#10b981',
//       color: '#ffffff',
//       border: 'none',
//       borderRadius: '4px',
//       fontSize: '12px',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.2s ease-in-out',
//       boxShadow: '0 2px 4px -1px rgba(16, 185, 129, 0.3)',
//       outline: 'none',
//       minWidth: '90px'
//     },
//     searchContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       marginBottom: '8px',
//       padding: '6px 8px',
//       backgroundColor: '#ffffff',
//       borderRadius: '4px',
//       boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
//       border: '1px solid #e2e8f0',
//       flexWrap: 'wrap'
//     },
//     searchInput: {
//       padding: '6px 8px',
//       border: '1px solid #e2e8f0',
//       borderRadius: '4px',
//       fontSize: '12px',
//       flex: '1',
//       minWidth: '200px',
//       backgroundColor: '#f8fafc',
//       color: '#374151',
//       transition: 'all 0.2s ease-in-out',
//       outline: 'none',
//       ':focus': {
//         borderColor: '#3b82f6',
//         backgroundColor: '#ffffff',
//         boxShadow: '0 0 0 2px rgba(59, 130, 246, 0.1)'
//       }
//     },
//     dataCount: {
//       fontSize: '11px',
//       fontWeight: '600',
//       color: '#6366f1',
//       backgroundColor: '#eef2ff',
//       padding: '4px 8px',
//       borderRadius: '12px',
//       border: '1px solid #c7d2fe'
//     },
//     loaderContainer: {
//       position: 'fixed',
//       top: '0',
//       left: '0',
//       width: '100%',
//       height: '100%',
//       backgroundColor: 'rgba(248, 250, 252, 0.95)',
//       backdropFilter: 'blur(4px)',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: '1000'
//     },
//     loaderCard: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '32px 40px',
//       backgroundColor: '#ffffff',
//       borderRadius: '12px',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//       border: '1px solid #e2e8f0',
//       minWidth: '300px',
//       textAlign: 'center'
//     },
//     loaderSpinner: {
//       width: '48px',
//       height: '48px',
//       marginBottom: '16px'
//     },
//     loaderText: {
//       fontSize: '16px',
//       fontWeight: '600',
//       color: '#374151',
//       marginBottom: '8px'
//     },
//     loaderSubtext: {
//       fontSize: '14px',
//       fontWeight: '400',
//       color: '#6b7280',
//       lineHeight: '1.5'
//     },
//     paginationContainer: {
//       marginBottom: '8px',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       gap: '4px',
//       padding: '6px',
//       backgroundColor: '#ffffff',
//       borderRadius: '4px',
//       boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
//       border: '1px solid #e2e8f0'
//     },
//     paginationButton: {
//       padding: '4px 8px',
//       border: '1px solid #e2e8f0',
//       backgroundColor: '#ffffff',
//       color: '#374151',
//       borderRadius: '4px',
//       cursor: 'pointer',
//       fontSize: '11px',
//       fontWeight: '500',
//       transition: 'all 0.2s ease-in-out',
//       outline: 'none',
//       minWidth: '32px'
//     },
//     paginationButtonActive: {
//       backgroundColor: '#3b82f6',
//       color: '#ffffff',
//       borderColor: '#3b82f6',
//       boxShadow: '0 2px 4px -1px rgba(59, 130, 246, 0.3)'
//     },
//     paginationInfo: {
//       marginLeft: '8px',
//       fontSize: '10px',
//       color: '#6b7280',
//       fontWeight: '500'
//     },
//     tableContainer: {
//       backgroundColor: '#ffffff',
//       borderRadius: '6px',
//       overflow: 'hidden',
//       boxShadow: '0 2px 4px -1px rgba(0, 0, 0, 0.1)',
//       border: '1px solid #e2e8f0'
//     },
//     tableScroll: {
//       overflowX: 'auto',
//       overflowY: 'auto',
//       maxHeight: '61vh'
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '13px',
//       backgroundColor: '#ffffff'
//     },
//     tableHeader: {
//       backgroundColor: '#f8fafc',
//       color: '#374151',
//       fontWeight: '600',
//       fontSize: '12px',
//       textTransform: 'uppercase',
//       letterSpacing: '0.3px',
//       position: 'sticky',
//       top: '0',
//       zIndex: '10'
//     },
//     tableHeaderCell: {
//       padding: '8px 6px',
//       textAlign: 'left',
//       borderBottom: '1px solid #e2e8f0',
//       borderRight: '1px solid #f1f5f9',
//       whiteSpace: 'nowrap',
//       cursor: 'pointer',
//       transition: 'background-color 0.2s ease-in-out'
//     },
//     sortHeader: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       gap: '8px'
//     },
//     sortIcons: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '0px'
//     },
//     sortIcon: {
//       fontSize: '12px',
//       color: '#94a3b8',
//       transition: 'color 0.2s ease-in-out'
//     },
//     sortIconActive: {
//       color: '#3b82f6'
//     },
//     tableRow: {
//       transition: 'background-color 0.2s ease-in-out',
//       borderBottom: '1px solid #f1f5f9'
//     },
//     tableCell: {
//       padding: '7px 5px',
//       textAlign: 'left',
//       borderRight: '1px solid #f8fafc',
//       wordWrap: 'break-word',
//       maxWidth: '160px',
//       fontSize: '12px'
//     },
//     stickyColumn: {
//       position: 'sticky',
//       backgroundColor: '#f8fafc',
//       zIndex: '5',
//       borderLeft: '2px solid #3b82f6',
//       borderRight: '2px solid #3b82f6',
//       boxShadow: '-2px 0 4px rgba(0, 0, 0, 0.1), 2px 0 4px rgba(0, 0, 0, 0.1)',
//       fontWeight: '600',
//       minWidth: '75px',
//       textAlign: 'center',
//       fontSize: '11px',
//       padding: '6px 4px'
//     },
//     stickyColumnHeader: {
//       position: 'sticky',
//       backgroundColor: '#e2e8f0',
//       zIndex: '10',
//       borderLeft: '2px solid #3b82f6',
//       borderRight: '2px solid #3b82f6',
//       boxShadow: '-2px 0 4px rgba(0, 0, 0, 0.15), 2px 0 4px rgba(0, 0, 0, 0.15)',
//       fontWeight: '700',
//       minWidth: '75px',
//       textAlign: 'center',
//       background: 'linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)',
//       fontSize: '11px',
//       padding: '7px 4px'
//     },
//     noData: {
//       textAlign: 'center',
//       padding: '40px 20px',
//       color: '#6b7280',
//       fontSize: '16px',
//       fontWeight: '500',
//       fontStyle: 'italic'
//     }
//   };

//   const userId = localStorage.getItem("userId");
//   const formattedFromDateForAPI = fromDate ? formatDateForAPI(fromDate) : "";
//   const formattedToDateForAPI = toDate ? formatDateForAPI(toDate) : "";
//   const [sortConfig, setSortConfig] = useState({
//     key: null,
//     direction: null
//   });

//   // Date validation function for 75 days maximum
//   const validateDateRange = (startDate, endDate) => {
//     if (!startDate || !endDate) return true; // Allow empty dates
    
//     const daysDiff = endDate.diff(startDate, 'day');
//     return daysDiff >= 0 && daysDiff <= 75; // Maximum 75 days range
//   };

//   // Update date range validation when dates change
//   useEffect(() => {
//     const isValid = validateDateRange(fromDate, toDate);
//     setIsDateRangeValid(isValid);
//   }, [fromDate, toDate]);

//   const sortData = (data, key, direction) => {
//     if (!key || !direction) return data;

//     return [...data].sort((a, b) => {
//       let aValue = a[key];
//       let bValue = b[key];

//       // Handle special cases for formatted dates
//       if (key === "orderDate" || key === "billingDateTime" || 
//           key === "deliveryScheduleDate" || key === "pickUpDateTime" || 
//           key === "deliveryDateTime") {
//         aValue = new Date(a[key]);
//         bValue = new Date(b[key]);
//       }
      
//       // Handle numeric values
//       if (key === "totalAmount") {
//         aValue = parseFloat(a[key]) || 0;
//         bValue = parseFloat(b[key]) || 0;
//       }

//       if (aValue === bValue) return 0;
      
//       if (direction === "ascending") {
//         return aValue > bValue ? 1 : -1;
//       } else {
//         return aValue < bValue ? 1 : -1;
//       }
//     });
//   };

//   // Handle sort
//   const handleSort = (key) => {
//     let direction = "ascending";
//     if (sortConfig.key === key && sortConfig.direction === "ascending") {
//       direction = "descending";
//     } else if (sortConfig.key === key && sortConfig.direction === "descending") {
//       direction = null;
//     }
//     setSortConfig({ key, direction });
//   };

//   // Sort header component
//   const SortHeader = ({ column, label }) => {
//     return (
//       <th 
//         onClick={() => handleSort(column)}
//         style={{
//           ...styles.tableHeaderCell,
//           cursor: 'pointer'
//         }}
//       >
//         <div style={styles.sortHeader}>
//           {label}
//           <div style={styles.sortIcons}>
//             <ArrowDropUpIcon 
//               style={{
//                 ...styles.sortIcon,
//                 ...(sortConfig.key === column && sortConfig.direction === "ascending" ? styles.sortIconActive : {})
//               }}
//             />
//             <ArrowDropDownIcon 
//               style={{
//                 ...styles.sortIcon,
//                 ...(sortConfig.key === column && sortConfig.direction === "descending" ? styles.sortIconActive : {})
//               }}
//             />
//           </div>
//         </div>
//       </th>
//     );
//   };

//   // Calculate pagination values
//   useEffect(() => {
//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     setDisplayData(filteredData.slice(indexOfFirstRecord, indexOfLastRecord));
//   }, [currentPage, filteredData]);

//   // Effect to apply sorting and update filtered data
//   useEffect(() => {
//     if (ledgerData.length > 0) {
//       const sortedData = sortData(ledgerData, sortConfig.key, sortConfig.direction);
//       setFilteredData(sortedData);
//       setCurrentPage(1); // Reset to first page after sorting
//     }
//   }, [sortConfig, ledgerData]);

//   const API_URL = `${local_url}/api/EcommOrderMovementReport/getLedgerListing/ALL/ECOMORDER/ALL/ALL/${selectedSfAreaId || "ALL"}/${formattedFromDateForAPI}/${formattedToDateForAPI}`;

//   const fetchLedgerData = async () => {
//     setLoading(true);
//     setFetchingData(true);
//     setError(null);
//     setHasSubmittedData(false); // Reset submission flag

//     try {
//       const token = localStorage.getItem('AuthorizationToken');
//       if (!token) {
//         setError("Authorization token is missing. Please log in again.");
//         localStorage.clear();
//         sessionStorage.clear();
//         window.location.href = "/login";
//         return;
//       }

//       // Make API call with Authorization header
//       const response = await fetch(API_URL, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.status === 401) {
//         console.error("Session expired or invalid token.");
//         localStorage.clear();
//         sessionStorage.clear();
//         alert("Session expired. Please log in again.");
//         window.location.href = "/login";
//         return;
//       }

//       if (!response.ok) {
//         throw new Error("Network response was not ok");
//       }

//       // Parse response data
//       const data = await response.json();
//       console.log(`Fetched ${data.length} records`);
//       setLedgerData(data);
//       setFilteredData(data);
//       setHasSubmittedData(true); // Mark as successfully submitted with data
//     } catch (error) {
//       console.error("Error fetching ledger data:", error);
//       setError("Failed to fetch ledger data. Please try again later.");
//     } finally {
//       setLoading(false);
//       setFetchingData(false);
//     }
//   };

//   const fetchSfAreas = async () => {
//     try {
//       const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//       if (!response.ok) throw new Error("Failed to fetch SF Areas");
//       const data = await response.json();
//       setSfAreas(data);
//     } catch (error) {
//       setError("Failed to fetch SF Areas. Please try again later.");
//     }
//   };

//   // const fetchBusinessChannels = async () => {
//   //   try {
//   //     const response = await fetch(`${local_signage}/api/v1/fetchbusinesschanneltype`);
//   //     if (!response.ok) throw new Error("Failed to fetch Business Channels");
//   //     const data = await response.json();
//   //     setBusinessChannels(data);
//   //   } catch (error) {
//   //     setError("Failed to fetch Business Channels. Please try again later.");
//   //   }
//   // };

//   const formatDateTime = (dateTime, formatType) => {
//     if (dateTime === "1753-01-01T00:00:00" || !dateTime) return "-";
//     const date = new Date(dateTime);
//     if (formatType === "date") {
//       return `${String(date.getDate()).padStart(2, "0")}-${String(
//         date.getMonth() + 1
//       ).padStart(2, "0")}-${date.getFullYear()}`;
//     }
//     if (formatType === "time") {
//       return `${String(date.getHours()).padStart(2, "0")}:${String(
//         date.getMinutes()
//       ).padStart(2, "0")}`;
//     }
//     return "-";
//   };

//   // Function to parse time slot (e.g., "09:00 AM - 10:30 AM")
//   const parseTimeSlot = (timeSlot) => {
//     if (!timeSlot || timeSlot === "-" || timeSlot === "NA") {
//       return { start: null, end: null };
//     }
    
//     try {
//       const [startStr, endStr] = timeSlot.split(" - ");
//       if (!startStr || !endStr) return { start: null, end: null };
      
//       const parseTime = (timeStr) => {
//         const [time, period] = timeStr.trim().split(" ");
//         const [hours, minutes] = time.split(":");
//         let hour24 = parseInt(hours);
        
//         if (period === "PM" && hour24 !== 12) hour24 += 12;
//         if (period === "AM" && hour24 === 12) hour24 = 0;
        
//         return { hours: hour24, minutes: parseInt(minutes) || 0 };
//       };
      
//       const start = parseTime(startStr);
//       const end = parseTime(endStr);
      
//       return { start, end };
//     } catch (error) {
//       return { start: null, end: null };
//     }
//   };

//   // Function to calculate delivery time duration (delivery date time - pickup date time)
//   const calculateDeliveryDuration = (deliveryDateTime, pickUpDateTime) => {
//     // Check if we have valid delivery and pickup times
//     if (!deliveryDateTime || deliveryDateTime === "1753-01-01T00:00:00" ||
//         !pickUpDateTime || pickUpDateTime === "1753-01-01T00:00:00") {
//       return "N/A";
//     }

//     try {
//       const deliveryDate = new Date(deliveryDateTime);
//       const pickupDate = new Date(pickUpDateTime);
      
//       // Check if dates are valid
//       if (isNaN(deliveryDate.getTime()) || isNaN(pickupDate.getTime())) {
//         return "N/A";
//       }
      
//       // Calculate difference in milliseconds
//       const diffMs = deliveryDate - pickupDate;
      
//       // If negative duration (pickup after delivery), return N/A
//       if (diffMs < 0) {
//         return "N/A";
//       }
      
//       // Convert to minutes, hours, and days
//       const diffMinutes = Math.floor(diffMs / (1000 * 60));
//       const diffHours = Math.floor(diffMinutes / 60);
//       const diffDays = Math.floor(diffHours / 24);
      
//       // Format the duration based on the time span
//       if (diffDays > 0) {
//         const remainingHours = diffHours % 24;
//         const remainingMinutes = diffMinutes % 60;
//         if (remainingHours > 0 && remainingMinutes > 0) {
//           return `${diffDays}d ${remainingHours}h ${remainingMinutes}m`;
//         } else if (remainingHours > 0) {
//           return `${diffDays}d ${remainingHours}h`;
//         } else if (remainingMinutes > 0) {
//           return `${diffDays}d ${remainingMinutes}m`;
//         } else {
//           return `${diffDays}d`;
//         }
//       } else if (diffHours > 0) {
//         const remainingMinutes = diffMinutes % 60;
//         if (remainingMinutes > 0) {
//           return `${diffHours}h ${remainingMinutes}m`;
//         } else {
//           return `${diffHours}h`;
//         }
//       } else {
//         return `${diffMinutes}m`;
//       }
//     } catch (error) {
//       console.error("Error calculating delivery duration:", error);
//       return "N/A";
//     }
//   };

//   // Function to calculate if delivery is delayed
//   const calculateDelayStatus = (deliveryDateTime, timeSlot, deliveryScheduleDate) => {
//     // Check if we have valid delivery date and time
//     if (!deliveryDateTime || deliveryDateTime === "1753-01-01T00:00:00") {
//       return { delayed: "NA", delayedBy: "No delivery time" };
//     }

//     // Parse time slot
//     const { start, end } = parseTimeSlot(timeSlot);
//     if (!start || !end) {
//       return { delayed: "NA", delayedBy: "Invalid time slot" };
//     }

//     // Create delivery date object
//     const deliveryDate = new Date(deliveryDateTime);
//     const scheduleDate = new Date(deliveryScheduleDate);
    
//     // Check if delivery was on the scheduled date
//     const isSameDate = deliveryDate.toDateString() === scheduleDate.toDateString();
    
//     if (!isSameDate) {
//       // Calculate days difference
//       const daysDiff = Math.floor((deliveryDate - scheduleDate) / (1000 * 60 * 60 * 24));
//       if (daysDiff > 0) {
//         return { delayed: "Yes", delayedBy: `${daysDiff} day(s)` };
//       } else if (daysDiff < 0) {
//         return { delayed: "No", delayedBy: "Early delivery" };
//       }
//     }

//     // Create time objects for the scheduled date
//     const endTimeScheduled = new Date(scheduleDate);
//     endTimeScheduled.setHours(end.hours, end.minutes, 0, 0);

//     // Compare delivery time with end of time slot
//     if (deliveryDate > endTimeScheduled) {
//       // Calculate delay in minutes
//       const delayMinutes = Math.floor((deliveryDate - endTimeScheduled) / (1000 * 60));
      
//       if (delayMinutes >= 60) {
//         const hours = Math.floor(delayMinutes / 60);
//         const mins = delayMinutes % 60;
//         return { 
//           delayed: "Yes", 
//           delayedBy: mins > 0 ? `${hours}h ${mins}m` : `${hours}h`
//         };
//       } else {
//         return { delayed: "Yes", delayedBy: `${delayMinutes}m` };
//       }
//     } else {
//       return { delayed: "No", delayedBy: "On time" };
//     }
//   };

//   const handleSfAreaChange = (event) => {
//     setSelectedSfAreaId(event.target.value);
//   };

//   const handleChannelTypeChange = (event) => {
//     setSelectedChannelType(event.target.value);
//   };

//   // Function to escape CSV values properly
//   const escapeCSV = (value) => {
//     if (value == null || value === undefined) return '""';
//     const stringValue = String(value);
//     // If the value contains quotes, commas, or newlines, wrap in quotes and escape quotes
//     if (stringValue.includes('"') || stringValue.includes(',') || stringValue.includes('\n')) {
//       return `"${stringValue.replace(/"/g, '""')}"`;
//     }
//     return stringValue;
//   };

//   const exportToCSV = async () => {
//     if (filteredData.length === 0) {
//       alert("No data to export");
//       return;
//     }

//     setExportLoading(true);
    
//     try {
//       // Create headers
//       const headers = [
//         "Sr.No",
//         "Sale Order ID",
//         "Order Date",
//         "Order Time",
//         "Current Status",
//         "Promo Code",
//         "POS Bill Number",
//         "Billing Branch",
//         "Billing Date",
//         "Billing Time",
//         "Delivery Schedule Date",
//         "Schedule Time Slot",
//         "Laziz CustId",
//         "POS CustId",
//         "Customer Mobile",
//         "Customer Name",
//         "Customer Address",
//         "Area",
//         "Pincode",
//         "Manager Name",
//         "WooComm Status",
//         "Delivery Branch ID",
//         "Total Amount",
//         "Delivery By",
//         "Pickup Date",
//         "Pickup Time",
//         "Delivery Date",
//         "Delivery Time",
//         "Delivery Duration",
//         "Delayed",
//         "Delayed By",
//       ];

//       // Start with BOM for Excel UTF-8 compatibility
//       let csvContent = '\ufeff';
//       csvContent += headers.join(",") + "\n";

//       // Process data in chunks to avoid memory issues with large datasets
//       const chunkSize = 500;
      
//       for (let i = 0; i < filteredData.length; i += chunkSize) {
//         const chunk = filteredData.slice(i, i + chunkSize);
        
//         // Process each chunk
//         for (let j = 0; j < chunk.length; j++) {
//           const item = chunk[j];
//           const index = i + j;
          
//           const orderDate = formatDateTime(item.orderDate, "date");
//           const orderTime = formatDateTime(item.orderDate, "time");
//           const billingDate = formatDateTime(item.billingDateTime, "date");
//           const billingTime = formatDateTime(item.billingDateTime, "time");
//           const scheduleDate = formatDateTime(item.deliveryScheduleDate, "date");
//           const deliveryDate = formatDateTime(item.deliveryDateTime, "date");
//           const deliveryTime = formatDateTime(item.deliveryDateTime, "time");
//           const pickupDate = formatDateTime(item.pickUpDateTime, "date");
//           const pickupTime = formatDateTime(item.pickUpDateTime, "time");
//           const delayStatus = calculateDelayStatus(item.deliveryDateTime, item.timeSlotName, item.deliveryScheduleDate);
//           const deliveryDuration = calculateDeliveryDuration(item.deliveryDateTime, item.pickUpDateTime);

//           const rowData = [
//             index + 1,
//             item.saleOrderID || "-",
//             orderDate,
//             orderTime,
//             item.systemStatus || "-",
//             item.promoCodes || "-",
//             item.saleId ? parseInt(item.saleId, 10) : "-",
//             item.saleBranchId || "-",
//             billingDate,
//             billingTime,
//             scheduleDate,
//             item.timeSlotName || "NA",
//             item.lazizCustID || "NA",
//             item.retailCustID || "NA",
//             item.mobile || "NA",
//             item.customerName || "NA",
//             escapeCSV(item.customerAddress || "NA"), // Properly escape address
//             item.areaName || "NA",
//             item.pincode || "NA",
//             item.managerName || "NA",
//             item.wooCommStatus || "NA",
//             item.delBranchID || "NA",
//             item.totalAmount ? item.totalAmount.toFixed(2) : "0.00",
//             item.deliveryBy || "-",
//             pickupDate,
//             pickupTime,
//             deliveryDate,
//             deliveryTime,
//             deliveryDuration,
//             delayStatus.delayed,
//             delayStatus.delayedBy,
//           ];

//           csvContent += rowData.map(value => escapeCSV(value)).join(",") + "\n";
//         }
        
//         // Allow the UI to update and prevent browser freeze
//         await new Promise(resolve => setTimeout(resolve, 0));
//       }

//       // Create and trigger download
//       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.setAttribute("href", url);
//       link.setAttribute("download", `order_movement_report_${fromDate ? fromDate.format('DD-MM-YYYY') : ''}_to_${toDate ? toDate.format('DD-MM-YYYY') : ''}.csv`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(url);
      
//     } catch (error) {
//       console.error("Error generating CSV:", error);
//       alert("Failed to export data. Please try again.");
//     } finally {
//       setExportLoading(false);
//     }
//   };

//   const applyFilters = () => {
//     let filtered = ledgerData;
    
//     // Apply search filter
//     if (searchQuery) {
//       const query = searchQuery.toLowerCase();
//       filtered = filtered.filter((item) =>
//         (item.saleOrderID && item.saleOrderID.toLowerCase().includes(query)) || 
//         (item.saleId && item.saleId.toLowerCase().includes(query))
//       );
//     }
    
//     // Apply delay filter
//     if (delayFilter !== "ALL") {
//       filtered = filtered.filter((item) => {
//         const delayStatus = calculateDelayStatus(item.deliveryDateTime, item.timeSlotName, item.deliveryScheduleDate);
//         return delayStatus.delayed === delayFilter;
//       });
//     }
    
//     setFilteredData(filtered);
//     setCurrentPage(1); // Reset to first page when filtering
//   };

//   const handleSearch = (event) => {
//     setSearchQuery(event.target.value.toLowerCase());
//   };

//   const handleDelayFilterChange = (event) => {
//     setDelayFilter(event.target.value);
//   };

//   // Expandable Address Component
//   const ExpandableAddress = ({ address, maxLength = 50 }) => {
//     const [isExpanded, setIsExpanded] = useState(false);
    
//     if (!address || address === '-' || address === 'NA') {
//       return <span>-</span>;
//     }
    
//     const shouldTruncate = address.length > maxLength;
//     const displayAddress = isExpanded || !shouldTruncate 
//       ? address 
//       : `${address.substring(0, maxLength)}...`;
    
//     return (
//       <div style={{ maxWidth: '300px', wordWrap: 'break-word' }}>
//         <span>{displayAddress}</span>
//         {shouldTruncate && (
//           <button
//             onClick={() => setIsExpanded(!isExpanded)}
//             style={{
//               marginLeft: '5px',
//               padding: '2px 6px',
//               fontSize: '11px',
//               backgroundColor: '#007bff',
//               color: 'white',
//               border: 'none',
//               borderRadius: '3px',
//               cursor: 'pointer',
//               fontWeight: 'bold'
//             }}
//             onMouseEnter={(e) => {
//               e.target.style.backgroundColor = '#0056b3';
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.backgroundColor = '#007bff';
//             }}
//           >
//             {isExpanded ? 'less' : 'more...'}
//           </button>
//         )}
//       </div>
//     );
//   };

//   // Apply filters whenever search query or delay filter changes
//   useEffect(() => {
//     applyFilters();
//   }, [searchQuery, delayFilter, ledgerData]);

//   useEffect(() => {
//     fetchSfAreas();
//     // fetchBusinessChannels();
//   }, []);

//   const handleSubmit = () => {
//     if (!selectedSfAreaId || selectedSfAreaId === "") {
//       alert('Please select an Area.');
//       return;
//     }

//     // if (!selectedChannelType || selectedChannelType === "") {
//     //   alert('Please select a Channel Type.');
//     //   return;
//     // }

//     if (!fromDate || !toDate) {
//       alert('Please select both From Date and To Date.');
//       return;
//     }

//     if (fromDate.isAfter(toDate)) {
//       alert('From Date cannot be after To Date.');
//       return;
//     }

//     if (!isDateRangeValid) {
//       alert('Date range cannot exceed 75 days. Please select a smaller date range.');
//       return;
//     }

//     fetchLedgerData();
//   };

//   // Pagination controls
//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);
//   const pageNumbers = [];
  
//   // Calculate which page numbers to show
//   const maxPageButtons = 5;
//   let startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
//   let endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
  
//   if (endPage - startPage + 1 < maxPageButtons) {
//     startPage = Math.max(1, endPage - maxPageButtons + 1);
//   }
  
//   for (let i = startPage; i <= endPage; i++) {
//     pageNumbers.push(i);
//   }

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   // Custom styles for date pickers with conditional red border
//   const getDatePickerStyle = (isValid = true) => ({
//     width: '100%',
//     minWidth: '180px',
//     '& .MuiInputBase-root': {
//       height: '40px',
//     },
//     '& .MuiOutlinedInput-root': {
//       '& fieldset': {
//         borderColor: isValid ? '#ccc' : '#f44336', // Red border when invalid
//       },
//       '&:hover fieldset': {
//         borderColor: isValid ? '#999' : '#f44336',
//       },
//       '&.Mui-focused fieldset': {
//         borderColor: isValid ? '#1976d2' : '#f44336',
//       },
//     },
//     '& .MuiInputLabel-root': {
//       color: isValid ? 'rgba(0, 0, 0, 0.6)' : '#f44336', // Red label when invalid
//     },
//   });

//   // Legacy date picker style for From Date (always valid styling)
//   const datePickerStyle = getDatePickerStyle();

//   return (
//     <>
//       <Header />
//       <div style={styles.container}>
//         {error && <div style={styles.errorMessage}>{error}</div>}
//         <div style={styles.inputContainer}>
//           <select
//             style={styles.dropdown}
//             value={selectedSfAreaId}
//             onChange={handleSfAreaChange}
//           >
//             <option value="" disabled>
//               Select Area 
//             </option>
//             <option value="ALL">ALL</option>
//             {sfAreas.map((area) => (
//               <option key={area.sfAreaId} value={area.sfAreaId}>
//                 {area.sfAreaName} ({area.sfAreaId})
//               </option>
//             ))}
//           </select>
// {/* 
//           <select
//             className="customer-dropdown"
//             value={selectedChannelType}
//             onChange={handleChannelTypeChange}
//           >
//             <option value="" disabled>
//               Select Channel Type
//             </option>
//             <option value="ALL">ALL</option>
//             {businessChannels.map((channel) => (
//               <option key={channel.ChannelType} value={channel.ChannelType}>
//                 {channel.ChannelTypeName}
//               </option>
//             ))}
//           </select> */}

//           <div style={styles.datePickerContainer}>
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <DatePicker
//                 label="From Date"
//                 value={fromDate}
//                 onChange={(newValue) => setFromDate(newValue)}
//                 format="DD-MM-YYYY"
//                 sx={datePickerStyle}
//                 slotProps={{
//                   textField: {
//                     size: "small",
//                     variant: "outlined"
//                   }
//                 }}
//               />
//             </LocalizationProvider>
//             {!isDateRangeValid && (
//               <div style={{ 
//                 fontSize: '12px', 
//                 color: '#f44336', 
//                 marginTop: '4px',
//                 fontWeight: '500'
//               }}>
//                 Date range cannot exceed 75 days
//               </div>
//             )}
//           </div>

//           <div style={{ margin: '3px' }}>
//             <span>-</span>
//           </div>

//           <div style={styles.datePickerContainer}>
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <DatePicker
//                 label="To Date"
//                 value={toDate}
//                 onChange={(newValue) => setToDate(newValue)}
//                 format="DD-MM-YYYY"
//                 sx={getDatePickerStyle(isDateRangeValid)}
//                 slotProps={{
//                   textField: {
//                     size: "small",
//                     variant: "outlined"
//                   }
//                 }}
//               />
//             </LocalizationProvider>
//             {!isDateRangeValid && (
//               <div style={{ 
//                 fontSize: '12px', 
//                 color: '#f44336', 
//                 marginTop: '4px',
//                 fontWeight: '500'
//               }}>
//                 {fromDate && toDate ? 
//                   `Range: ${toDate.diff(fromDate, 'day')} days (max 75 days allowed)` :
//                   'Date range cannot exceed 75 days'
//                 }
//               </div>
//             )}
//           </div>

//           <button
//             onClick={handleSubmit}
//             style={{
//               ...styles.submitButton,
//               opacity: (loading || !selectedSfAreaId ||  !isDateRangeValid) ? 0.6 : 1,
//               cursor: (loading || !selectedSfAreaId || !isDateRangeValid) ? 'not-allowed' : 'pointer'
//             }}
//             disabled={loading || !selectedSfAreaId || !isDateRangeValid}
//           >
//             {fetchingData ? "Loading..." : "Submit"}
//           </button>
//           <button
//             onClick={exportToCSV}
//             style={{
//               ...styles.exportButton,
//               opacity: (loading || !hasSubmittedData || filteredData.length === 0 || exportLoading || !isDateRangeValid ) ? 0.6 : 1,
//               cursor: (loading || !hasSubmittedData || filteredData.length === 0 || exportLoading || !isDateRangeValid ) ? 'not-allowed' : 'pointer'
//             }}
//             disabled={loading || !hasSubmittedData || filteredData.length === 0 || exportLoading || !isDateRangeValid }
//           >
//             {exportLoading ? "Exporting..." : "Export to CSV"}
//           </button>
//         </div>

//         {/* Search Bar, Delay Filter and Data Count */}
//         <div style={styles.searchContainer}>
//           <input
//             type="text"
//             placeholder="Search Sale Order ID or POS Bill Number"
//             value={searchQuery}
//             onChange={handleSearch}
//             style={styles.searchInput}
//           />
//           <select
//             value={delayFilter}
//             onChange={handleDelayFilterChange}
//             style={styles.dropdown}
//           >
//             <option value="ALL">All Deliveries</option>
//             <option value="Yes">Delayed</option>
//             <option value="No">On Time</option>
//             <option value="NA">No Data</option>
//           </select>
//           {filteredData.length > 0 && (
//             <div style={styles.dataCount}>
//               Total Records: {filteredData.length}
//             </div>
//           )}
//         </div>

//         {/* Loading Indicator */}
// {fetchingData && (
//   <div style={styles.loaderContainer}>
//     <div style={styles.loaderCard}>
//       <CircularProgress 
//         size={48}
//         thickness={4}
//         style={styles.loaderSpinner}
//         sx={{
//           color: '#3b82f6',
//           '& .MuiCircularProgress-circle': {
//             strokeLinecap: 'round',
//           }
//         }}
//       />
//       <div style={styles.loaderText}>Loading Sale Order Data</div>
//       <div style={styles.loaderSubtext}>
//         Please wait while we fetch your data...
//         <br />
//         This may take a few moments.
//       </div>
//     </div>
//   </div>
// )}

//         {/* Pagination Controls - Top */}
//         {filteredData.length > recordsPerPage && (
//           <div style={styles.paginationContainer}>
//             <button 
//               onClick={() => paginate(1)} 
//               disabled={currentPage === 1}
//               style={{
//                 ...styles.paginationButton,
//                 opacity: currentPage === 1 ? 0.5 : 1,
//                 cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
//               }}
//             >
//               First
//             </button>
//             <button 
//               onClick={() => paginate(currentPage - 1)} 
//               disabled={currentPage === 1}
//               style={{
//                 ...styles.paginationButton,
//                 opacity: currentPage === 1 ? 0.5 : 1,
//                 cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
//               }}
//             >
//               Prev
//             </button>
            
//             {pageNumbers.map(number => (
//               <button
//                 key={number}
//                 onClick={() => paginate(number)}
//                 style={{
//                   ...styles.paginationButton,
//                   ...(currentPage === number ? styles.paginationButtonActive : {})
//                 }}
//               >
//                 {number}
//               </button>
//             ))}
            
//             <button 
//               onClick={() => paginate(currentPage + 1)} 
//               disabled={currentPage === totalPages}
//               style={{
//                 ...styles.paginationButton,
//                 opacity: currentPage === totalPages ? 0.5 : 1,
//                 cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
//               }}
//             >
//               Next
//             </button>
//             <button 
//               onClick={() => paginate(totalPages)} 
//               disabled={currentPage === totalPages}
//               style={{
//                 ...styles.paginationButton,
//                 opacity: currentPage === totalPages ? 0.5 : 1,
//                 cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
//               }}
//             >
//               Last
//             </button>
//             <span style={styles.paginationInfo}>
//               Page {currentPage} of {totalPages}
//             </span>
//           </div>
//         )}

//         <div style={styles.tableContainer}>
//           <div style={styles.tableScroll}>
//             <table style={styles.table}>
//               <thead style={styles.tableHeader}>
//                 <tr>
//                   <th style={styles.tableHeaderCell}>Sr.No</th>
//                   <SortHeader column="saleOrderID" label="Sale Order ID" />
//                   <SortHeader column="orderDate" label="Order Date" />
//                   <SortHeader column="orderDate" label="Order Time" />
//                   <SortHeader column="systemStatus" label="Current Status" />
//                   <SortHeader column="promoCodes" label="Promo Codes" />
//                   <SortHeader column="saleId" label="POS Bill Number" />
//                   <SortHeader column="saleBranchId" label="Billing Branch" />
//                   <SortHeader column="billingDateTime" label="Billing Date" />
//                   <SortHeader column="billingDateTime" label="Billing Time" />
//                   <SortHeader column="deliveryScheduleDate" label="Schedule Date" />
//                   <SortHeader column="timeSlotName" label="Schedule Time Slot" />
//                   <SortHeader column="lazizcustomerId" label="Laziz CustID" />
//                   <SortHeader column="customerId" label="POS CustID" />
//                   <SortHeader column="customerMobile" label="Customer Mobile" />
//                   <SortHeader column="customerName" label="Customer Name" />
//                   <SortHeader column="customerAddress" label="Customer Address" />
//                   <SortHeader column="areaName" label="Area" />
//                   <SortHeader column="pincode" label="Pincode" />
//                   <SortHeader column="managerName" label="Manager Name" />
//                   <SortHeader column="wooCommStatus" label="WooComm Status" />
//                   <SortHeader column="delBranchID" label="Delivery Branch" />
//                   <SortHeader column="totalAmount" label="Total Amount" />
//                   <SortHeader column="deliveryBy" label="Delivery By" />
//                   <SortHeader column="pickUpDateTime" label="Pickup Date" />
//                   <SortHeader column="pickUpDateTime" label="Pickup Time" />
//                   <SortHeader column="deliveryDateTime" label="Delivery Date" />
//                   <SortHeader column="deliveryDateTime" label="Delivery Time" />
//                   <th style={{...styles.tableHeaderCell, ...styles.stickyColumnHeader, right: '150px', minWidth: '75px'}}>Duration</th>
//                   <th style={{...styles.tableHeaderCell, ...styles.stickyColumnHeader, right: '75px', minWidth: '75px'}}>Status</th>
//                   <th style={{...styles.tableHeaderCell, ...styles.stickyColumnHeader, right: '0px', minWidth: '75px'}}>Delayed By</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {displayData.length > 0 ? (
//                   displayData.map((item, index) => {
//                     const actualIndex = (currentPage - 1) * recordsPerPage + index;
//                     const delayStatus = calculateDelayStatus(item.deliveryDateTime, item.timeSlotName, item.deliveryScheduleDate);
//                     const deliveryDuration = calculateDeliveryDuration(item.deliveryDateTime, item.pickUpDateTime);
//                     return (
//                       <tr key={index} style={styles.tableRow}>
//                         <td style={styles.tableCell}>{actualIndex + 1}</td>
//                         <td style={styles.tableCell}>{item.saleOrderID || "-"}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.orderDate, "date")}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.orderDate, "time")}</td>
//                         <td style={styles.tableCell}>{item.systemStatus || "-"}</td>
//                         <td style={styles.tableCell}>{item.promoCodes || "-"}</td>                       
//                         <td style={styles.tableCell}>{item.saleId ? parseInt(item.saleId, 10) : "-"}</td>
//                         <td style={styles.tableCell}>{item.saleBranchId || "-"}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.billingDateTime, "date")}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.billingDateTime, "time")}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.deliveryScheduleDate, "date")}</td>
//                         <td style={styles.tableCell}>{item.timeSlotName || "-"}</td>
//                         <td style={styles.tableCell}>{item.lazizCustID || "-"}</td>
//                         <td style={styles.tableCell}>{item.retailCustID || "-"}</td>
//                         <td style={styles.tableCell}>{item.mobile || "-"}</td>
//                         <td style={styles.tableCell}>{item.customerName || "-"}</td>
//                         <td style={styles.tableCell}><ExpandableAddress address={item.customerAddress} /></td>
//                         <td style={styles.tableCell}>{item.areaName || "-"}</td>
//                         <td style={styles.tableCell}>{item.pincode || "-"}</td>
//                         <td style={styles.tableCell}>{item.managerName || "-"}</td>
//                         <td style={styles.tableCell}>{item.wooCommStatus || "-"}</td>
//                         <td style={styles.tableCell}>{item.delBranchID || "-"}</td>
//                         <td style={styles.tableCell}>₹{item.totalAmount?.toFixed(2) || "0.00"}</td>
//                         <td style={styles.tableCell}>{item.deliveryBy || "-"}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.pickUpDateTime, "date")}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.pickUpDateTime, "time")}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.deliveryDateTime, "date")}</td>
//                         <td style={styles.tableCell}>{formatDateTime(item.deliveryDateTime, "time")}</td>
//                         <td style={{...styles.tableCell, ...styles.stickyColumn, right: '150px', minWidth: '75px'}}>{deliveryDuration}</td>
//                         <td 
//                           style={{ 
//                             ...styles.tableCell, 
//                             ...styles.stickyColumn, 
//                             right: '75px',
//                             minWidth: '75px',
//                             color: delayStatus.delayed === 'Yes' ? '#dc2626' : delayStatus.delayed === 'No' ? '#059669' : '#d97706',
//                             backgroundColor: delayStatus.delayed === 'Yes' ? '#fef2f2' : delayStatus.delayed === 'No' ? '#f0fdf4' : '#fffbeb',
//                             fontWeight: '700',
//                             fontSize: '10px'
//                           }}
//                         >
//                           {delayStatus.delayed === 'Yes' ? '🔴 LATE' : delayStatus.delayed === 'No' ? '🟢 OK' : '🟡 N/A'}
//                         </td>
//                         <td style={{...styles.tableCell, ...styles.stickyColumn, right: '0px', minWidth: '75px'}}>{delayStatus.delayedBy}</td>
//                       </tr>
//                     );
//                   })
//                 ) : fetchingData ? (
//                   <tr>
//                     <td colSpan="30" style={styles.noData}>
//                       Loading data...
//                     </td>
//                   </tr>
//                 ) : (
//                   <tr>
//                     <td colSpan="30" style={styles.noData}>
//                       No data available
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>


//       </div>

//       {/* CSS for pagination and date picker */}
//       <style>{`
//         .pagination-container {
//           margin: 15px 0;
//         }
//         .pagination-button {
//           padding: 5px 10px;
//           margin: 0 2px;
//           border: 1px solid #ccc;
//           background: #f5f5f5;
//           cursor: pointer;
//           color: black;
//         }
//         .pagination-button:disabled {
//           opacity: 0.5;
//           cursor: not-allowed;
//         }
//         .pagination-active {
//           background: #007bff;
//           color: white;
//           border-color: #007bff;
//         }
//         .data-count {
//           margin-left: 15px;
//           font-weight: bold;
//         }
//         .loader-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           margin: 20px 0;
//         }
//         .date-picker-container {
//           min-width: 180px;
//           margin: 0 5px;
//         }
//         .customer-date-input-container {
//           display: flex;
//           align-items: center;
//           flex-wrap: wrap;
//           gap: 2px;
//           margin-bottom: 20px;
//         }
        
//         /* Sticky columns */
//         .sticky-duration-column {
//           position: sticky !important;
//           right: 200px !important;
//           background: #F1F5F9 !important;
//           border-left: 1px solid #ddd !important;
//           z-index: 10 !important;
//           min-width: 140px !important;
//           text-align: center !important;
//           font-weight: bold !important;
//         }
        
//         .sticky-delayed-column {
//           position: sticky !important;
//           right: 120px !important;
//           background: #F1F5F9 !important;
//           border-left: 1px solid #ddd !important;
//           z-index: 10 !important;
//           min-width: 80px !important;
//           text-align: center !important;
//           font-weight: bold !important;
//         }
        
//         .sticky-delayed-by-column {
//           position: sticky !important;
//           right: 0px !important;
//           background: #F1F5F9 !important;
//           border-left: 1px solid #ddd !important;
//           z-index: 10 !important;
//           min-width: 120px !important;
//           text-align: center !important;
//           font-weight: bold !important;
//         }
        
//         /* Header styling for sticky columns with shiny black-white gradient */
//         thead .sticky-duration-column {
//           background: linear-gradient(45deg, #4a4a4a 5%, #ffffff 10%,#004d00 75%, #000000 100%) !important;
//           background-size: 200% 200% !important;
//           animation: shine 3s ease-in-out infinite !important;
//           color: white !important;
//           text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8) !important;
//           font-weight: bold !important;
//           position: sticky !important;
//           right: 200px !important;
//           z-index: 15 !important;
//         }
        
//         thead .sticky-delayed-column {
//           background: linear-gradient(45deg, #4a4a4a 5%, #ffffff 10%,#004d00 75%, #000000 100%) !important;
//           background-size: 200% 200% !important;
//           animation: shine 3s ease-in-out infinite !important;
//           color: white !important;
//           text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8) !important;
//           font-weight: bold !important;
//           position: sticky !important;
//           right: 120px !important;
//           z-index: 15 !important;
//         }
        
//         thead .sticky-delayed-by-column {
//           background: linear-gradient(45deg, #4a4a4a 5%, #ffffff 5%,#004d00 75%, #000000 100%) !important;
//           background-size: 200% 200% !important;
//           animation: shine 3s ease-in-out infinite !important;
//           color: white !important;
//           text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8) !important;
//           font-weight: bold !important;
//           position: sticky !important;
//           right: 0px !important;
//           z-index: 15 !important;
//         }
        
//         /* Shiny animation keyframes */
//         @keyframes shine {
//           0% { background-position: 0% 0%; }
//           50% { background-position: 100% 100%; }
//           100% { background-position: 0% 0%; }
//         }
        
//         @media (max-width: 768px) {
//           .date-picker-container {
//             width: 100%;
//             margin: 5px 0;
//           }
//           .customer-date-input-container {
//             flex-direction: column;
//             align-items: stretch;
//           }
          
//           .sticky-duration-column {
//             right: 160px !important;
//             min-width: 100px !important;
//             font-size: 12px !important;
//           }
          
//           .sticky-delayed-column {
//             right: 100px !important;
//             min-width: 60px !important;
//             font-size: 12px !important;
//           }
          
//           .sticky-delayed-by-column {
//             right: 0px !important;
//             min-width: 100px !important;
//             font-size: 12px !important;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default SaleOrderReport;